export default "__VITE_ASSET__CTcYV56$__"